// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + ({"279":"hero","308":"burger","369":"carousel","481":"apartment-selector","592":"common","768":"page","842":"map"}[chunkId] || chunkId) + ".js";
};